/* ==========================================================================
   LOVI — LOT 18 (07/08/2026)
   1. Vignettes de palier : passage a une variante CDN plus grande.
   2. Video mecanisme : lecture auto, muette, en boucle, sans controle,
      + repli sur les trois images Temps 1/2/3 si la video ne peut pas jouer.

   Charge par snippets/custom-code-body.liquid, en defer, apres lovi-lot16.js.
   Auto-neutralisant : ne fait rien si la page ne contient ni .lovi2-pk__img
   ni [data-lovi-mech-video]. Aucun garde-fou sur le handle de page, pour
   qu'un futur duplicata de la PDP herite du correctif.

   Hooks JS a ne pas casser (aucun n'est touche ici) : data-lpdp-pack,
   data-variant-id, data-gifts, data-unlock, data-price-text,
   data-compare-text, .is-selected, .is-locked, __loviAtcPrice,
   packs[idx].click() du quiz, [data-rc-prev/next/dot] du carrousel d'avis.
   ========================================================================== */
(function () {
  'use strict';

  /* ------------------------------------------------------------------
     1. VIGNETTES DE PALIER — variante CDN 160 -> 400 px
     ------------------------------------------------------------------
     Le buybox emet les vignettes en ?width=160. Le lot 18 les rend a
     76 px (mobile) et 88 px (desktop) : a devicePixelRatio 2 il faut
     176 px de source, la variante 160 etait donc sous-dimensionnee et
     serait apparue molle. On ne touche QUE le parametre width, l'URL et
     le parametre de version ?v= sont conserves tels quels.
     ------------------------------------------------------------------ */
  function upscaleThumbs() {
    var imgs = document.querySelectorAll('.lovi2-pk__img');
    if (!imgs.length) return;
    Array.prototype.forEach.call(imgs, function (img) {
      try {
        var u = new URL(img.getAttribute('src'), window.location.href);
        if (!u.searchParams.has('width')) return;
        if (parseInt(u.searchParams.get('width'), 10) >= 400) return;
        u.searchParams.set('width', '400');
        img.setAttribute('src', u.pathname + u.search);
      } catch (e) { /* URL non parsable : on laisse la source d'origine */ }
    });
  }

  /* ------------------------------------------------------------------
     2. VIDEO MECANISME
     ------------------------------------------------------------------
     Specification Hunt : autoplay muted loop playsinline preload=metadata,
     aucun controle, pas de bouton play, pas de son, redemarrage infini.

     Repli : si la video ne peut pas jouer (erreur de l'element, source
     illisible, ou aucune donnee recue au bout de 15 s), on RE-AFFICHE les
     trois images Temps 1/2/3 en retirant leur classe de masquage, et on
     masque la video. Une panne CDN ne laisse donc pas un trou dans la page.
     Les trois <img> ne sont JAMAIS retirees du DOM, seulement masquees.
     ------------------------------------------------------------------ */
  var HIDDEN = 'lovi-mech-img--hidden';
  var DEAD   = 'lovi-mech-video--dead';

  function revealImages(video, reason) {
    var section = video.closest ? video.closest('.lpdp') : null;
    var scope = section || document;
    var imgs = scope.querySelectorAll('.' + HIDDEN);
    Array.prototype.forEach.call(imgs, function (img) {
      img.classList.remove(HIDDEN);
    });
    var wrap = video.parentNode;
    if (wrap && wrap.classList) wrap.classList.add(DEAD);
    /* trace lisible pour un futur diagnostic, sans bruit console */
    video.setAttribute('data-lovi-mech-fallback', reason || 'unknown');
  }

  function setupVideo() {
    var video = document.querySelector('[data-lovi-mech-video]');
    if (!video) return;

    /* Ceinture et bretelles : les proprietes DOM en plus des attributs.
       defaultMuted force l'attribut muted a etre pris en compte par la
       politique d'autoplay de Chrome meme si un script tiers l'a efface. */
    video.muted = true;
    video.defaultMuted = true;
    video.loop = true;
    video.playsInline = true;
    video.controls = false;
    video.setAttribute('muted', '');
    video.removeAttribute('controls');

    /* Connexion economique : on retrograde en 480p avant tout chargement. */
    try {
      var c = navigator.connection;
      var sd = video.getAttribute('data-lovi-mech-sd');
      if (sd && c && (c.saveData || /(^|-)2g$/.test(c.effectiveType || ''))) {
        var source = video.querySelector('source');
        if (source) {
          source.setAttribute('src', sd);
          video.load();
        }
      }
    } catch (e) { /* pas de Network Information API : on garde le 720p */ }

    var settled = false;
    function fail(reason) {
      if (settled) return;
      settled = true;
      revealImages(video, reason);
    }
    function ok() {
      if (settled) return;
      settled = true;
    }

    video.addEventListener('error', function () { fail('media-error'); });
    var source = video.querySelector('source');
    if (source) source.addEventListener('error', function () { fail('source-error'); });
    video.addEventListener('loadeddata', ok);
    video.addEventListener('playing', ok);

    /* Detecteur de panne : au bout de 15 s, si l'element n'a toujours ni
       metadonnees ni le moindre octet tamponne, on considere la source
       morte. Le seuil est volontairement large pour ne pas declencher le
       repli sur une simple connexion lente. */
    window.setTimeout(function () {
      if (settled) return;
      var noData = video.readyState === 0 &&
                   (!video.buffered || video.buffered.length === 0);
      if (noData) fail('timeout-no-data');
    }, 15000);

    /* Relance de la lecture : au chargement, puis a chaque fois que la
       video redevient visible. Chrome suspend la lecture d'un onglet en
       arriere-plan ; sans cette relance la video reste figee au retour. */
    function tryPlay() {
      if (settled && video.hasAttribute('data-lovi-mech-fallback')) return;
      var p = video.play();
      if (p && typeof p.catch === 'function') {
        p.catch(function () { /* rejet d'autoplay : le poster reste affiche */ });
      }
    }

    tryPlay();
    document.addEventListener('visibilitychange', function () {
      if (document.visibilityState === 'visible') tryPlay();
    });

    if ('IntersectionObserver' in window) {
      var io = new IntersectionObserver(function (entries) {
        entries.forEach(function (entry) {
          if (entry.isIntersecting) tryPlay();
        });
      }, { threshold: 0.1 });
      io.observe(video);
    }
  }

  function init() {
    upscaleThumbs();
    setupVideo();
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }
})();